import React, { PureComponent } from "react";

import Loader from "components/Loader/Loader.js";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LeeTotalStarts extends PureComponent {
  render() {
    const { loading, data } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={200} />;
    }
    if (loading) {
      return <Loader minHeight={200} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="row mt-2">
        <div className="col-7 mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Total Starts
          </Heading>

          <div className="d-flex">
            <Metric {...data.data.total_starts} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">New Starts</h6>
            <Metric {...data.data.new_starts} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Restarts</h6>
            <Metric {...data.data.restarts} size={"xs"} />
          </div>
        </div>
      </div>
    );
  }
}

export default LeeTotalStarts;
